import ActionTypes from "./Types";
import HttpClient from "../utils/HttpClient";

export function getProfile() {
    return dispatch => new HttpClient().profile()
        .then(
            data => { console.log('data', data); return dispatch({ type: ActionTypes.GET_PROFILE, data: data }) },
            err => { console.log("Could not get profile", err); }
        )
}

export async function getProfile2() {
    return await new HttpClient().profile();
}

export function updateProfile(profile, success) {
    return dispatch => new HttpClient().updateProfile(profile, success)
        .then(
            data => dispatch({ type: ActionTypes.UPDATE_PROFILE, data }),
            err => dispatch({ type: ActionTypes.SHOW_ERROR_MESSAGE, error: err })
        );
}

export function removeProfileValues(values) {
    const profile = { favorites: [], subscriptions: [], searches: [] };
    values.forEach(v => {
        if (v.type === "favorites"){ console.log("favorites", v, v.type, v.value); profile.favorites.push(v.value);}
        if (v.type === "subscriptions") profile.subscriptions.push(v.value);
        if (v.type === "searches") profile.searches.push(JSON.parse(v.value));
    });
    return async dispatch => {        
        return new HttpClient().removeFromProfile(profile)
        .then(
            data => dispatch({ type: ActionTypes.UPDATE_PROFILE, data }),
            err => dispatch({ type: ActionTypes.SHOW_ERROR_MESSAGE, error: err })
        );}
}

export function saveSearch(criteria) {
    return dispatch => new HttpClient().saveSearch(criteria)
        .then(
            data => dispatch({ type: ActionTypes.UPDATE_PROFILE, data }),
            err => dispatch({ type: ActionTypes.SHOW_ERROR_MESSAGE, error: err })
        );
}